function buocXacNhanThanhToan() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Gửi về kế toán",
      content:
        "Phiếu đã lưu. Kiểm tra lại số liệu rồi gửi về kế toán — kế toán sẽ nhận thông tin và thanh toán, bạn không tự đánh dấu đã thanh toán nữa.",
    },
    {
      target: "#tour-xac-nhan-chuyen-khoan",
      title: "Bước 2 · Thông tin chuyển khoản",
      content:
        "Đối chiếu số tài khoản / số tiền với chủ vườn. Kế toán sẽ dùng thông tin này khi chuyển khoản — bạn có thể chép để kiểm tra nhanh.",
      placement: "top",
    },
    {
      target: "#tour-xac-nhan-nut",
      title: "Bước 3 · Gửi về kế toán",
      content:
        'Bấm "Gửi về kế toán" khi số liệu đã đúng. Sau đó phiếu vào hàng chờ của kế toán; nếu bị trả lại bạn sẽ thấy ghi chú để sửa.',
      placement: "top",
    },
  ];
}

export default buocXacNhanThanhToan;
